// extracted by mini-css-extract-plugin
module.exports = {"suggestionList":"SuggestionList_suggestionList__2Z3L3","suggestion":"SuggestionList_suggestion__39Yy1","selected":"SuggestionList_selected__wBhFy"};